//PDP Menu
window.addEventListener("pageshow", () => {
  const menuLinks = document.querySelectorAll(".product-nav-wrapper a");
  if (!menuLinks.length) return;

  const ids = ['product-description', 'product-specs', 'product-reviews', 'product-video', 'related-products'];

  const setActive = (id) => {
    menuLinks.forEach(l => l.classList.remove("active"));
    const activeLink = document.querySelector(`.product-nav-wrapper a[href="#${id}"]`);
    if (activeLink) {
      activeLink.classList.add("active");
      const nav = document.querySelector(".product-nav-wrapper");
      nav.scrollTo({
        left: activeLink.offsetLeft - nav.clientWidth / 2 + activeLink.clientWidth / 2,
        behavior: "smooth"
      });
    }
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      setActive(entry.target.id);
    });
  }, { rootMargin: "0% 0px -90% 0px", threshold: 0 });

  ids.forEach(id => {
    const el = document.getElementById(id);
    if (el) observer.observe(el);
  });

  const lastSection = document.getElementById('related-products');
  if (lastSection) {
    window.addEventListener("scroll", () => {
      const nav = document.querySelector(".shopify-section--product-nav");
      if (!nav) return;
      const bottom = lastSection.getBoundingClientRect().bottom;
      nav.style.transform = bottom < 0 ? "translateY(-100%)" : "translateY(0)";
    }, { passive: true });
  }

  // Init au chargement
  const hash = window.location.hash;
  if (hash) {
    setActive(hash.replace('#', ''));
  } else {
    setActive(ids[0]);
  }
});


// Autoplay sliders
document.addEventListener("DOMContentLoaded", function () {
  const observerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0.5
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const carousel = entry.target;
      const isVisible = entry.isIntersecting;

      const shouldAutoplay = carousel.dataset.autoplay === "true";
      const interval = parseInt(carousel.dataset.interval || "5000", 10);
      const carouselId = carousel.id;
      const nextBtn = document.querySelector(`button[is="next-button"][aria-controls="${carouselId}"]`);
      const prevBtn = document.querySelector(`button[is="prev-button"][aria-controls="${carouselId}"]`);
      const scrollContent = carousel.scrollLeft;
      const maxScroll = carousel.scrollWidth - carousel.clientWidth;

      if (!shouldAutoplay || !nextBtn || !prevBtn) return;

      function scrollOrReset() {
        const atEnd = Math.abs(carousel.scrollLeft - maxScroll) < 5;

        if (atEnd) {
          // Revenir au début
          carousel.scrollTo({ left: 0, behavior: "smooth" });
        } else {
          nextBtn.click();
        }
      }

      if (isVisible && !carousel._autoplayActive) {
        carousel._autoplayInterval = setInterval(scrollOrReset, interval);
        carousel._autoplayActive = true;
      }

      if (!isVisible && carousel._autoplayActive) {
        clearInterval(carousel._autoplayInterval);
        carousel._autoplayActive = false;
      }
    });
  }, observerOptions);

  document.querySelectorAll("scroll-carousel").forEach(carousel => {
    observer.observe(carousel);
  });
});

//Search bar placeholders
document.addEventListener("DOMContentLoaded", function () {
  const input = document.getElementById("dynamicPlaceholder");
  if (!input) return;

  const raw = input.dataset.placeholders || "";
  const placeholders = raw.split(',').map(p => p.trim()).filter(Boolean);

  if (placeholders.length === 0) return;

  let index = 0;
  function updatePlaceholder() {
    input.placeholder = placeholders[index];
    index = (index + 1) % placeholders.length;
  }

  updatePlaceholder();
  setInterval(updatePlaceholder, 3000);
});

//View more
(() => {
  "use strict";
  window.addEventListener("load", function () {
    if (window.innerWidth >= 1000) {
      var e = document.querySelector("[data-hide-images]"),
          t = document.querySelector("[data-show-images]");
      if (e) {
        var i = e.querySelectorAll(".product-gallery__media")[4];
        if (i) {
          var n = function () {
            window.innerWidth >= 1000
              ? (e.style.maxHeight = i.offsetTop + 150 + "px")
              : (e.style.maxHeight = "");
          };
          n();
          window.addEventListener("resize", n);
        }
        t && t.addEventListener("click", function () {
          e.removeAttribute("data-hide-images");
          e.style.maxHeight = "";
          t.remove();
        });
      }
    }
  });
})();

//Display mode
document.addEventListener('DOMContentLoaded', () => {
  const displayModeButtons = document.querySelector('.display-mode');
  if (!displayModeButtons) return;

  const productList = document.querySelector('product-list');
  const gridButton = displayModeButtons.querySelector('.grid-button');
  const listButton = displayModeButtons.querySelector('.list-button');

  gridButton.addEventListener('click', () => applyMode(false));
  listButton.addEventListener('click', () => applyMode(true));

  function applyMode(isList) {
    productList.classList.toggle('display_mode_list', isList);
    gridButton.classList.toggle('active', !isList);
    listButton.classList.toggle('active', isList);
  }
});

/**
 * <quantity-updater>
 *
 * Gère les boutons +/- sur les line items du panier et du drawer.
 * S'appuie sur le LineItemQuantity natif du thème pour l'update cart.
 */
class QuantityUpdater extends HTMLElement {
  connectedCallback() {
    this._abortController = new AbortController();
    const signal = this._abortController.signal;

    // On écoute sur this directement plutôt que de stocker les refs
    // pour éviter les timing issues avec is="quantity-input"
    this.addEventListener('click', (e) => {
      if (e.target.hasAttribute('data-quantity-decrement')) this._decrement();
      if (e.target.hasAttribute('data-quantity-increment')) this._increment();
    }, { signal });
  }

  disconnectedCallback() {
    this._abortController.abort();
  }

  get input() {
    return this.querySelector('input[type="number"]');
  }

  _decrement() {
    const input = this.input;
    const step = parseInt(input.step) || 1;
    const min  = parseInt(input.min)  || 0;
    const next = parseInt(input.value) - step;

    if (next < min) return;

    input.value = next;
    this._triggerChange(input);
  }

  _increment() {
    const input = this.input;
    const step = parseInt(input.step) || 1;
    const max  = input.max ? parseInt(input.max) : Infinity;
    const next = parseInt(input.value) + step;

    if (next > max) return;

    input.value = next;
    this._triggerChange(input);
  }

  _triggerChange(input) {
    input.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
  }
}

if (!window.customElements.get('quantity-updater')) {
  window.customElements.define('quantity-updater', QuantityUpdater);
}

// Linked products — hover label
window.addEventListener('pageshow', () => {
  document.querySelectorAll('.product-info__product-picker .variant-picker__option').forEach(axis => {
    const label = axis.querySelector('.variant-picker__option-info span');
    if (!label) return;
 
    const defaultText = label.textContent;
 
    axis.querySelectorAll('.thumbnail-swatch').forEach(option => {
      const optionLabel = option.querySelector('.sr-only')?.textContent?.trim();
      if (!optionLabel) return;
 
      option.addEventListener('mouseenter', () => { label.textContent = optionLabel; });
      option.addEventListener('mouseleave', () => { label.textContent = defaultText; });
    });
  });
});


// Size Guide - Crosshair highlight + Arrow indicator
document.querySelectorAll('[aria-controls^="size_guide"]').forEach(btn => {
  btn.addEventListener('click', () => {
    const drawer = document.getElementById(btn.getAttribute('aria-controls'));
    if (!drawer) return;

    setTimeout(() => {
      if (!drawer.dataset.crosshairInit) {
        drawer.dataset.crosshairInit = 'true';

        const highlight = (td) => {
          const table = td.closest('.table-size_guide');
          const row = td.closest('tr');
          const colIndex = td.cellIndex;
          if (row.rowIndex === 0 || colIndex === 0) return;

          table.querySelectorAll('tr').forEach(r => r.classList.remove('row-highlight'));
          table.querySelectorAll('td').forEach(c => c.classList.remove('col-highlight', 'cell-hover'));
          row.classList.add('row-highlight');
          table.querySelectorAll(`tr td:nth-child(${colIndex + 1})`).forEach(c => c.classList.add('col-highlight'));
          td.classList.add('cell-hover');
        };

        const clear = (table) => {
          table.querySelectorAll('tr').forEach(r => r.classList.remove('row-highlight'));
          table.querySelectorAll('td').forEach(c => c.classList.remove('col-highlight', 'cell-hover'));
        };

        drawer.querySelectorAll('.table-size_guide').forEach(table => {
          if (!window.matchMedia('(hover: none)').matches) {
            table.addEventListener('mouseover', (e) => {
              const td = e.target.closest('td');
              if (td) highlight(td);
            });
            table.addEventListener('mouseout', () => clear(table));
          } else {
            table.addEventListener('touchstart', (e) => {
              const td = e.target.closest('td');
              if (td) highlight(td);
            });
          }
        });
      }

      drawer.querySelectorAll('.size_guide_content').forEach(block => {
        const table = block.querySelector('.table-size_guide');
        if (!table || block.querySelector('.table-scroll-indicator')) return;

        if (table.scrollWidth > table.clientWidth + 20) {
          const indicator = document.createElement('div');
          indicator.classList.add('table-scroll-indicator');
          indicator.innerHTML = `<svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg>`;
          block.appendChild(indicator);

          table.addEventListener('scroll', () => {
            block.classList.toggle('is-scrolled-end', table.scrollLeft + table.clientWidth >= table.scrollWidth - 5);
          }, { passive: true });
        }
      });
    }, 100);
  });
});

// Layered Nav - Autoscroll to active badge
const scrollLayeredNav = () => {
  const nav = document.querySelector('.layered-nav');
  const active = nav?.querySelector('.button.active');
  if (!nav || !active) return;

  const navLeft = nav.getBoundingClientRect().left;
  const activeLeft = active.getBoundingClientRect().left;
  const activeCenter = activeLeft - navLeft + active.offsetWidth / 2;
  const scrollTarget = activeCenter - nav.offsetWidth / 2;

  nav.scrollLeft = scrollTarget;
};

document.addEventListener('DOMContentLoaded', scrollLayeredNav);
document.addEventListener('turbo:load', scrollLayeredNav);

/* ----------------------------------------------------------------------------
 * <video-playlist>
 * - Switches the main YouTube player when a sidebar thumbnail is clicked.
 * - Fetches each video title via YouTube oEmbed (cached in localStorage).
 * - Toggles a bottom fade overlay on the sidebar based on scroll position.
 * -------------------------------------------------------------------------- */
const VIDEO_PLAYLIST_TITLE_CACHE = 'maxesport:videoTitles:v1';

class VideoPlaylist extends HTMLElement {
  connectedCallback() {
    this.mainMedia = this.querySelector('video-media');
    if (!this.mainMedia) return;

    this.mainContainer = this.querySelector('.video-playlist__main');
    this.posterImg = this.mainMedia.querySelector('img.video-playlist__poster');
    this.template = this.mainMedia.querySelector('template');
    this.sidebar = this.querySelector('.video-playlist__sidebar');
    this.sidebarWrap = this.querySelector('.video-playlist__sidebar-wrap');

    this.querySelectorAll('[data-video-id]').forEach((btn) => {
      btn.addEventListener('click', () => this._switchTo(btn));
      this._loadVideoTitle(btn);
    });

    this._setupSidebarHeightSync();
    this._setupSidebarFade();
  }

  _setupSidebarHeightSync() {
    if (!this.mainContainer || !this.sidebarWrap) return;

    const mql = window.matchMedia('(min-width: 1000px)');

    const updateHeight = () => {
      if (!mql.matches) {
        this.sidebarWrap.style.height = '';
        return;
      }
      const h = this.mainContainer.getBoundingClientRect().height;
      if (h > 0) this.sidebarWrap.style.height = `${h}px`;
    };

    new ResizeObserver(updateHeight).observe(this.mainContainer);
    mql.addEventListener('change', updateHeight);
    updateHeight();
  }

  _switchTo(btn) {
    const videoId = btn.dataset.videoId;
    const thumbnail = btn.dataset.thumbnail;
    if (!videoId) return;

    this.querySelectorAll('[data-video-id]').forEach((b) => b.removeAttribute('aria-current'));
    btn.setAttribute('aria-current', 'true');

    const origin = encodeURIComponent(window.location.origin);
    const src = `https://www.youtube.com/embed/${videoId}?playsinline=1&autoplay=1&playlist=${videoId}&enablejsapi=1&rel=0&modestbranding=1&origin=${origin}`;

    const existingIframe = this.mainMedia.querySelector('iframe');
    if (existingIframe) {
      existingIframe.src = src;
    } else {
      const tplIframe = this.template?.content?.querySelector('iframe');
      if (tplIframe) tplIframe.src = src;
      this.mainMedia.click();
    }

    if (this.posterImg && thumbnail) this.posterImg.src = thumbnail;
  }

  async _loadVideoTitle(btn) {
    const videoId = btn.dataset.videoId;
    const titleEl = btn.querySelector('.video-playlist__item-title');
    if (!videoId || !titleEl) return;

    const cache = this._readTitleCache();
    if (cache[videoId]) {
      titleEl.textContent = cache[videoId];
      return;
    }

    try {
      const oembedUrl = `https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${videoId}&format=json`;
      const res = await fetch(oembedUrl);
      if (!res.ok) return;
      const data = await res.json();
      if (data?.title) {
        titleEl.textContent = data.title;
        cache[videoId] = data.title;
        this._writeTitleCache(cache);
      }
    } catch (_) {
      /* keep placeholder title */
    }
  }

  _readTitleCache() {
    try {
      return JSON.parse(localStorage.getItem(VIDEO_PLAYLIST_TITLE_CACHE) || '{}');
    } catch (_) {
      return {};
    }
  }

  _writeTitleCache(cache) {
    try {
      localStorage.setItem(VIDEO_PLAYLIST_TITLE_CACHE, JSON.stringify(cache));
    } catch (_) {
      /* quota exceeded, ignore */
    }
  }

  _setupSidebarFade() {
    if (!this.sidebar || !this.sidebarWrap) return;

    const updateFadeState = () => {
      const noOverflow = this.sidebar.scrollHeight <= this.sidebar.clientHeight + 1;
      const atBottom = this.sidebar.scrollTop + this.sidebar.clientHeight >= this.sidebar.scrollHeight - 2;
      this.sidebarWrap.dataset.noOverflow = noOverflow ? 'true' : 'false';
      this.sidebarWrap.dataset.atBottom = atBottom ? 'true' : 'false';
    };

    this.sidebar.addEventListener('scroll', updateFadeState, { passive: true });
    new ResizeObserver(updateFadeState).observe(this.sidebar);
    updateFadeState();
  }
}

if (!window.customElements.get('video-playlist')) {
  window.customElements.define('video-playlist', VideoPlaylist);
}


// Share popover: open upwards when there isn't enough room below the trigger.
// Runs in capture phase so the anchor is set before the theme opens the popover.
document.addEventListener('click', (event) => {
  const control = event.target.closest('[aria-controls]');
  if (!control) return;

  const popover = document.getElementById(control.getAttribute('aria-controls'));
  if (!popover || !popover.classList.contains('share-popover') || popover.hasAttribute('open')) return;

  // The popover is hidden via visibility/display: force layout briefly to measure it
  const previousDisplay = popover.style.display;
  popover.style.display = 'block';
  const popoverHeight = popover.offsetHeight || 320;
  popover.style.display = previousDisplay;

  const spaceBelow = window.innerHeight - control.getBoundingClientRect().bottom;
  popover.setAttribute('anchor-vertical', spaceBelow >= popoverHeight + 24 ? 'end' : 'start');
}, true);


class CountdownTimer extends HTMLElement {
  #interval;
  #display;
  #expired;
  #units = [];
  #hideWhenExpired = false;
  #end = null;

  connectedCallback() {
    this.#display = this.querySelector('[data-countdown-display]');
    this.#expired = this.querySelector('[data-expired-message]');
    this.#units = [...this.querySelectorAll('[data-unit]')];
    this.#hideWhenExpired = this.dataset.hideWhenExpired === 'true';
    this.#end = this.#resolveEndTimestamp();

    if (!this.#end) return;

    this.#tick();
    this.#interval = window.setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.#interval);
  }

  #resolveEndTimestamp() {
    const { endDate, endTime = '23:59', endTimestamp, timezone = 'shop' } = this.dataset;
    if (!endDate) return null;

    if (timezone === 'local') {
      const parsed = Date.parse(`${endDate}T${endTime}:00`);
      return Number.isNaN(parsed) ? null : parsed;
    }

    if (timezone === 'UTC') {
      const parsed = Date.parse(`${endDate}T${endTime}:00Z`);
      return Number.isNaN(parsed) ? null : parsed;
    }

    const shopTimestamp = Number.parseInt(endTimestamp, 10);
    return Number.isNaN(shopTimestamp) ? null : shopTimestamp * 1000;
  }

  #tick() {
    const distance = this.#end - Date.now();
    if (distance <= 0) return this.#expire();

    const parts = {
      days: Math.floor(distance / 86400000),
      hours: Math.floor((distance % 86400000) / 3600000),
      minutes: Math.floor((distance % 3600000) / 60000),
      seconds: Math.floor((distance % 60000) / 1000)
    };

    this.#units.forEach((el) => {
      el.textContent = String(parts[el.dataset.unit] ?? 0).padStart(2, '0');
    });
  }

  #expire() {
    window.clearInterval(this.#interval);
    this.#units.forEach((el) => { el.textContent = '00'; });
    this.classList.add('is-expired');

    if (this.#hideWhenExpired && this.#display) {
      this.#display.hidden = true;
    }

    this.#expired?.classList.remove('hidden');
  }
}

if (!window.customElements.get('countdown-timer')) {
  window.customElements.define('countdown-timer', CountdownTimer);
}


// Scrolling text : la section Liquid ne rend que 10 copies du texte, ce qui
// laisse un vide à droite sur les écrans très larges. On clone les copies
// jusqu'à couvrir la largeur du conteneur (+1 copie pour la boucle du marquee).
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.scrolling-text__wrapper').forEach((wrapper) => {
    const container = wrapper.closest('.scrolling-text');
    if (!container) return;

    const fill = () => {
      const spans = wrapper.querySelectorAll('.scrolling-text__text');
      const spanWidth = spans[0]?.getBoundingClientRect().width;
      if (!spanWidth) return;

      const needed = Math.min(Math.ceil(container.clientWidth / spanWidth) + 2, 60);
      for (let i = spans.length; i < needed; i++) {
        wrapper.appendChild(spans[spans.length - 1].cloneNode(true));
      }

      // Les clones démarrent leur animation CSS à l'insertion : sans resync,
      // leur phase est décalée et les textes se superposent à la jonction.
      const reference = spans[0].getAnimations()[0];
      if (reference?.currentTime != null) {
        wrapper.querySelectorAll('.scrolling-text__text').forEach((span) => {
          span.getAnimations().forEach((animation) => {
            animation.currentTime = reference.currentTime;
          });
        });
      }
    };

    fill();
    document.fonts?.ready.then(fill);
    new ResizeObserver(fill).observe(container);
  });
});